import * as React from 'react';
import { ArticleParagraph3, ArticleHeading4, Avatar } from '@cian/ui-kit';

import * as styles from './Author.css';

interface IAuthorProps {
  contactsButton?: React.ReactNode;
  label: string;
  logoUrl?: string | null;
  name: string;
}

export const Author = ({ name, logoUrl, label, contactsButton }: IAuthorProps) => {
  const avatarType = React.useMemo(() => (logoUrl ? 'builder' : 'agency'), [logoUrl]);

  return (
    <div className={styles['footer']} data-testid="Author">
      <div className={styles['logo']}>
        <Avatar size={40} src={logoUrl} type={avatarType} />
      </div>
      <div className={styles['description']}>
        <ArticleParagraph3 color="gray60_100">{label}</ArticleParagraph3>
        <ArticleHeading4>{name}</ArticleHeading4>
      </div>
      {contactsButton && <div className={styles['button']}>{contactsButton}</div>}
    </div>
  );
};
